import { useCallback, useEffect, useState } from "react";
import { icons_data, iconsPromise } from "../PropertyComponents/IconData";

export const useGenerateHTML = () => {
  const [loadedIcons, setLoadedIcons] = useState(icons_data);
  useEffect(() => {
    if (icons_data.length === 0) {
      iconsPromise
        .then((fetchedIcons) => {
          setLoadedIcons(fetchedIcons);
        })
        .catch((error) => {
          console.error("Failed to load icons:", error);
        });
    }
  }, []);

  const generateHTMLContent = useCallback((elements, parentId = null) => {
    let html = "";
    const defaultHeaders = ["Header 1", "Header 2", "Header 3"];
    const defaultRows = [
      ["Row 1, Cell 1", "Row 1, Cell 2", "Row 1, Cell 3"],
      ["Row 2, Cell 1", "Row 2, Cell 2", "Row 2, Cell 3"],
      ["Row 3, Cell 1", "Row 3, Cell 2", "Row 3, Cell 3"],
    ];
    elements
      .filter((el) => el.parentId === parentId)
      .forEach((el) => {
        const className = el.classname ? `${el.classname}` : `element-${el.id}`;
        const ID = el.Id_For_html ? `id="${el.Id_For_html}"` : "";
        const TabIndex =
          el.pseudoClass === "active" || el.pseudoClass === "focus"
            ? ` tabindex = "0" `
            : "";

        switch (el.type) {
          case "DroppableDiv":
            html += `<div class="${className}" ${ID} ${TabIndex} >\n`;
            html += generateHTMLContent(elements, el.id);
            html += `</div>\n`;
            break;
          case "DroppableMain":
            html += `<main class="${className}" ${ID} ${TabIndex} >\n`;
            html += generateHTMLContent(elements, el.id);
            html += `</main>\n`;
            break;
          case "DroppableArticle":
            html += `<article class="${className}" ${ID} ${TabIndex} >\n`;
            html += generateHTMLContent(elements, el.id);
            html += `</article>\n`;
            break;
          case "DroppableHorizontalRule":
            html += `<hr class="${className}" ${ID}/>\n`;
            break;
          case "DroppableLineBreak":
            html += `<br />\n`;
            break;
          case "DroppableAside":
            html += `<aside class="${className}" ${ID} ${TabIndex} >\n`;
            html += generateHTMLContent(elements, el.id);
            html += `</aside>\n`;
            break;
          case "DroppableForm":
            html += `<form class="${className}" ${ID} ${
              el.formname ? `name="${el.formname || ""}"` : ""
            }
            action="${el.action || "/submit"}"
            method="${el.method || "post"}"
            autoComplete="${el.autocomplete === "true" ? "on" : "off"}"
            enctype="${el.enctype || "multipart/form-data"}"
            ${el.novalidate === "true" ? "noValidate" : ""}
            target="${el.target || "_blank"}"${TabIndex}>\n`;
            html += generateHTMLContent(elements, el.id);
            html += `</form>\n`;
            break;
          case "DroppableNav":
            html += `<nav class="${className}" ${ID} ${TabIndex}>\n`;
            html += generateHTMLContent(elements, el.id);
            html += `</nav>\n`;
            break;
          case "DroppableHeader":
            html += `<header class="${className}" ${ID} ${TabIndex}>\n`;
            html += generateHTMLContent(elements, el.id);
            html += `</header>\n`;
            break;
          case "DroppableHGroup":
            html += `<hgroup class="${className}" ${ID} ${TabIndex}>\n`;
            html += generateHTMLContent(elements, el.id);
            html += `</hgroup>\n`;
            break;
          case "DroppableFooter":
            html += `<footer class="${className}" ${ID} ${TabIndex}>\n`;
            html += generateHTMLContent(elements, el.id);
            html += `</footer>\n`;
            break;
          case "DroppableSection":
            html += `<section class="${className}" ${ID} ${TabIndex}>\n`;
            html += generateHTMLContent(elements, el.id);
            html += `</section>\n`;
            break;
          case "DroppableSpan":
            html += `<span class="${className}" ${ID} ${TabIndex}>\n`;
            html += generateHTMLContent(elements, el.id);
            html += `</span>\n`;
            break;
          case "DroppableButton":
            html += `<button class="${className}" ${ID}>${
              el.label || "Button"
            }</button>\n`;
            break;
          case "DroppableImage":
            html += `<img class="${className}" ${ID} src="${
              el.src || ""
            }" alt="${el.alt || ""}">\n`;
            break;
          case "DroppableIframe":
            html += `<iframe class="${className}" ${ID} src="${
              el.sourceIframe || "https://nexgenwebcon.netlify.app/about"
            }"title=${el.tilteForFrame || "NexGen Web Builder"}"></iframe>\n`;
            break;
          case "DroppableParagraph":
            html += `<p class="${className}" ${ID} ${TabIndex}>${
              el.text || ""
            }</p>\n`;
            break;
          case "DroppableHeading":
            html += `<h${
              el.level || 1
            } class="${className}" ${ID} ${TabIndex}>${el.text || ""}</h${
              el.level || 1
            }>\n`;
            break;
          case "DroppableLink":
            html += `<a class="${className}" ${ID} href="${
              el.href || "#"
            }" target="${el.target || "_self"}" rel="${el.rel || ""}">${
              el.text || "Link"
            }</a>\n`;
            break;
          case "DroppableIcon":
            const findIconByName = (iconName) => {
              const lowerCaseIconName = iconName.toLowerCase();
              return (
                loadedIcons.find(
                  (ic) => ic.icon_name.toLowerCase() === lowerCaseIconName
                ) || null
              );
            };

            let iconData = {
              class: "fa-solid fa-icons",
              icon_name: "icon",
              cdn_name: "FontAwesome",
            };

            if (el.iconName) {
              iconData = findIconByName(el.iconName);
            }

            html += `<i class="${iconData.class} ${className}" ${ID}></i>\n`;
            break;
          case "DroppableList":
            const listType = el.Type === "ol" ? "ol" : "ul";
            html += `<${listType} class="${className}" ${ID}>\n`;
            html += el.items
              ? el.items
                  .split("\n")
                  .map((item) => `<li>${item.trim()}</li>`)
                  .join("\n")
              : "<li>1</li>\n <li>2</li>\n <li>3</li>\n";
            html += `</${listType}>\n`;
            break;
          case "DroppableTable":
            const headers = el.headers ? el.headers.split(",") : defaultHeaders;
            const rows = el.data
              ? el.data.split(";").map((row) => row.split(","))
              : defaultRows;

            // Parse colspan and rowspan data
            const spanMap = new Map();
            if (el.colspanRowspan) {
              el.colspanRowspan.split(";").forEach((span) => {
                const [row, col, colspan, rowspan] = span
                  .split(",")
                  .map(Number);
                spanMap.set(`${row},${col}`, { colspan, rowspan });
              });
            }

            // Function to check if a cell should be rendered
            const shouldRenderCell = (rowIndex, cellIndex) => {
              for (let i = 0; i < rowIndex; i++) {
                const span = spanMap.get(`${i},${cellIndex}`);
                if (span && span.rowspan > rowIndex - i) {
                  return false;
                }
              }
              return true;
            };

            html += `<table class="${className}" ${ID}>\n`;

            // Render table header
            html += `<thead>\n<tr>\n`;
            headers.forEach((header, index) => {
              if (shouldRenderCell(0, index)) {
                const span = spanMap.get(`0,${index}`);
                const colspanAttr =
                  span && span.colspan > 1 ? ` colspan="${span.colspan}"` : "";
                const rowspanAttr =
                  span && span.rowspan > 1 ? ` rowspan="${span.rowspan}"` : "";
                html += `<th${colspanAttr}${rowspanAttr}>${header.trim()}</th>\n`;
              }
            });
            html += `</tr>\n</thead>\n`;

            // Render table body
            html += `<tbody>\n`;
            rows.forEach((row, rowIndex) => {
              html += `<tr>\n`;
              row.forEach((cell, cellIndex) => {
                if (shouldRenderCell(rowIndex + 1, cellIndex)) {
                  const span = spanMap.get(`${rowIndex + 1},${cellIndex}`);
                  const colspanAttr =
                    span && span.colspan > 1
                      ? ` colspan="${span.colspan}"`
                      : "";
                  const rowspanAttr =
                    span && span.rowspan > 1
                      ? ` rowspan="${span.rowspan}"`
                      : "";
                  html += `<td${colspanAttr}${rowspanAttr}>${cell.trim()}</td>\n`;
                }
              });
              html += `</tr>\n`;
            });
            html += `</tbody>\n`;

            html += `</table>\n`;
            break;
          case "DroppableVideo":
            html += `<video class="${className}" ${ID}
                  src="${el.url || el.src || ""}"
                  poster="${el.posterUrl || el.poster || ""}"
                  ${el.autoplay ? "autoplay" : ""}
                  ${el.controls !== false ? "controls" : ""}
                  ${el.loop ? "loop" : ""}
                  ${el.muted ? "muted" : ""}
                  preload="${el.preload || "auto"}"
                >
                  Your browser does not support the video tag.
                </video>\n`;
            break;
          case "DroppableCheckbox":
            html += `<label class="${className}" ${ID}>\n`;
            html += `<input type="checkbox" ${el.checked ? "checked" : ""} ${
              el.disabled ? "disabled " : ""
            } ${el.required ? "required" : ""}>\n`;
            html += `${el.label || "Checkbox"}\n`;
            html += `</label>\n`;
            break;
          case "DroppableRadio":
            html += `<label class="${className}" ${ID}>\n`;
            html += `<input type="radio" name="${el.groupName}" ${
              el.checked ? "checked" : ""
            } ${el.disabled ? "disabled" : ""} ${
              el.required ? "required" : ""
            }>\n`;
            html += `${el.label || "Radio Button"}\n`;
            html += `</label>\n`;
            break;
          case "DroppableTextInput":
            html += `<label class="${className}-label"  ${ID}>${
              el.label || "Text Label"
            }</label>\n`;
            html += `<input type="text" class="${className}-input"  ${ID} placeholder="${
              el.placeholder || ""
            }" value="${el.value || ""}"/>\n`;
            break;
          case "DroppableOutput":
            html += `<output for="${el.for || ""}" name="${
              el.nameX || ""
            }" class="${className}-input"  ${ID}>\n`;
            html += `${el.value || "Result"}`;
            html += `<output/>`;
            break;
          case "DroppablePasswordInput":
            html += `<label class="${className}-label"  ${ID}>\n`;
            html += `${el.label || "Password"}</label>\n`;
            html += `<input type="password" class="${className}-input"  ${ID} placeholder="${
              el.placeholder || "Enter password"
            }" value="${el.value || ""}" />\n`;
            break;
          case "DroppableEmailInput":
            html += `<label class="${className}-label"  ${ID}>\n`;
            html += `${el.label || "Email Label"}</label>\n`;
            html += `<input type="email" class="${className}-input"  ${ID} placeholder="${
              el.placeholder || "Enter your email"
            }" value="${el.value || ""}" pattern="${
              el.pattern || "[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,}$"
            }" />\n`;
            break;
          case "DroppableNumberInput":
            html += `<label class="${className}-label"  for=${el.Id_For_html}>\n`;
            html += `${el.label || "Number Label"}</label>\n`;
            html += `<input type="number" class="${className}-input"  ${ID} placeholder="${
              el.placeholder || "Enter a number"
            }" value="${el.value || ""}" min="${el.min || ""}" max="${
              el.max || ""
            }" step="${el.step || ""}"  />\n`;
            break;
          case "DroppableDateInput":
            html += `<label class="${className}-label"  ${ID}>\n`;
            html += `${el.label || "Date"}</label>\n`;
            html += `<input type="date" class="${className}-input"  ${ID} placeholder="${
              el.placeholder || "Enter a date"
            }" value="${el.value || ""}" pattern="${el.pattern || ""}" />\n`;
            break;
          case "DroppableColorInput":
            html += `<label class="${className}-label"  ${ID}>\n`;
            html += `${el.label || "Color"}</label>\n`;
            html += `<input type="color" class="${className}-input"  ${ID} value="${
              el.value || "#000000"
            }">\n`;
            break;
          case "DroppableFileInput":
            html += `<label class="${className}-label"  ${ID}>\n`;
            html += `${el.label || "File Input"}\n`;
            html += `<input type="file" class="${className}-input"  ${ID} placeholder="${
              el.placeholder || "Select a file"
            }" accept="${el.accept || ""}" ${el.multiple ? "multiple" : ""} ${
              el.disabled ? "disabled" : ""
            } ${el.required ? "required" : ""} capture="${
              el.capture || ""
            }" directory="${el.directory || ""}" webkitdirectory="${
              el.webkitdirectory || ""
            }">\n`;
            html += `</label>\n`;
            break;
            case "DroppableRangeInput":
              html += `<label class="${className}" for="${el.Id_For_html}">${
                el.label || "Range Label"
              }</label>\n`;
            
              html += `<input 
                type="range" 
                class="${className}-input"  
                ${ID || `id=${el.id}`} 
                min="${el.minValue || "0"}" 
                max="${el.maxValue || "100"}" 
                step="${el.stepValue || "1"}" 
                oninput="document.getElementById('output-${el.id}').value = this.value"
                value="${el.value || el.minValue || "0"}">\n`;
            
              // Adding the output element to display the range value
              html += `               <output id="output-${el.id}" name="Output"">
                ${el.value || el.minValue || "0"}
              </output>\n`;
            
              break;
            
          case "DroppableAudio":
            html += `<audio
              src="${el.url || el.src || ""}"
              ${el.autoplay ? "autoplay" : ""}
              ${el.controls !== false ? "controls" : ""}
              ${el.loop ? "loop" : ""}
              ${el.muted ? "muted" : ""}
              preload="${el.preload || "auto"}">
              Your browser does not support the audio element.
            </audio>\n`;
            break;
          case "DroppableDropDown":
            html += `<select class="${className}" ${ID} ${
              el.multiple ? "multiple" : ""
            } ${el.disabled ? "disabled" : ""}>\n`;

            const options = el.options
              ? el.options.split(",").map((option) => option.trim())
              : ["DropDownOptions"];

            options.forEach((option) => {
              html += `<option value="${option}">${option}</option>\n`;
            });

            html += `</select>\n`;
            break;
          case "DroppableMap":
            const iframeUrl = `https://maps.google.com/maps?q=${
              el.lat || 21.232887638669023
            },${el.lng || 72.86806076829943}&z=13&output=embed`;

            html += `         <iframe \n              title="${
              el.titleMap || "NexGen"
            }"\n              src="${iframeUrl}"\n              width="100%"\n              height="100%"\n              style="border:0; border-radius:${
              el.borderRadius || "0"
            };"\n              allowfullscreen=""\n              loading="lazy">\n          </iframe>\n`;
            break;
          default:
            console.warn(`Unsupported element type: ${el.type}`);
        }
      });
    return html;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const generateHTML = useCallback(
    (elements, pageName) => {
      const content = generateHTMLContent(elements);

      let safePageName = "";
      if (
        pageName &&
        typeof pageName.name === "string" &&
        pageName.name.trim() !== ""
      ) {
        safePageName = pageName.name.replace(/\s+/g, "_");
      } else {
        if (!pageName) {
          console.warn("No current page is defined.");
        } else if (typeof pageName.name !== "string") {
          console.warn("Current page name is not a valid string.");
        } else if (pageName.name.trim() === "") {
          console.warn("Current page name is an empty string.");
        }
        safePageName = "default_page_name";
      }

      return `
  <!DOCTYPE html>
  <html lang="en">
  <head>
      <meta charset="UTF-8">
      <meta name="viewport" content="width=device-width, initial-scale=1.0">
       <link href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css" rel="stylesheet">
       <link href="https://cdn.jsdelivr.net/npm/bootstrap-icons@1.10.5/font/bootstrap-icons.css" rel="stylesheet">
      <title>Generated Website</title>
      <link rel="stylesheet" href="${safePageName}.css">
      </head>
      <body>  
      ${content}
      <script src="${safePageName}.js"></script>
  </body>
  </html>
  
      `.trim();
    },
    [generateHTMLContent]
  );
  return { generateHTML };
};
